import React, { useState, useEffect } from 'react'
import { MSG } from "../../constants/toastMessages";
import { IoCloseOutline } from "react-icons/io5";
import { toast } from 'react-toastify';
import { apiCallingPost } from '../../api/services';

function ListReject(props) {
  const [rejectText, setRejectText] = useState("")

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        props.cancelPopup();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const rejectList = async (datas) => {
    let postData = {
      videoId: datas.video_id,
      rejectReason: rejectText,
      userId: props?.userData?.userId
    }
    let flag = true;
    if (rejectText === "") {
      document.getElementById("rejectText").focus()
      toast.error(MSG.rejectReasonRequired)
      flag = false;
    }
    if (flag === true) {
      try {
        const response = await apiCallingPost("api/video/rejectVideo", postData)
        const { data } = response
        if (data.success === "1") {
          toast.success(`${datas.fileType} rejected.`);
          setRejectText("")
          setTimeout(() => {
            props.getData("", "");
          }, 1000);
          setTimeout(() => {
            props.cancelPopup()
          }, 1500);
        }
        else {
          toast.error(MSG.genericError);
        }

      } catch (error) {
        console.error("Error Approved Video:", error);
      }
    }
  }
  return (

    <div className="modal-admin-wrapper">
      <div className="modal-ad-popup modal-lg">
        <div className="modal-innerpopup ">
          <div className="modal-headdiv d-flex justify-content-between">
            <h5 className="modal-head">Reason for Rejection</h5>
            <span className="closeBtn"><IoCloseOutline size={32} onClick={() => props.cancelPopup()} /></span>
          </div>
          <div className="modal-admin-body">
            <div className="">
              <input type="text" className="editInput" maxlength="40" readOnly
                value={`${props.rejectData.video_heading}`} placeholder='Video Heading' />
              <textarea className="editTextInput" id="rejectText" placeholder="Comments" maxlength="120"
                value={rejectText} onChange={(e) => setRejectText(e.target.value)}></textarea>
            </div>
            <div className="editPanelButton">
              <button className="saveButton" onClick={() => rejectList(props.rejectData)}>Reject</button>
              <button className="cancelButton" onClick={() => props.cancelPopup()}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListReject